import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getPriceOperation = createAsyncThunk('/GetPriceOperation', async () => {
  const response = await axios.get(`/GetTmpPriceOperation`);
  return response.data;
});

export const getSingaporeSmsNps = createAsyncThunk('/GetSingaporeSmsNps', async () => {
  const response = await axios.get(`/GetSingaporeSmsNps`);
  return response.data;
});

export const setPriceOperation = createAsyncThunk('/SetPriceOperation', async (push) => {
  const response = await axios.post(`/SetTmpPriceOperation`, push);
  return response.data;
});

export const setSingaporeSmsNps = createAsyncThunk('/SetSingaporeSmsNps', async (push) => {
  const response = await axios.post(`/SetSingaporeSmsNps`, push);
  return response.data;
});

export const setSmsEmailSendingDataForThailand = createAsyncThunk('/SetSmsEmailSendingDataForThailand', async (push) => {
  const response = await axios.post(`/SetSmsEmailSendingDataForThailand`, push);
  return response.data;
});

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const priceOperationSlice = createSlice({
  name: 'warrantyTimeException',
  initialState: {
    loading: false,
    error: '',
    PriceOperation: [],
    SingaporeSmsNps: [],
    SelectedAppTranslationId: 0,
    response: '',
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
  },

  extraReducers: {

    [getPriceOperation.pending]: (state) => {
      state.loading = true;
    },
    [getPriceOperation.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPriceOperation.fulfilled]: (state, action) => {
      state.PriceOperation = action.payload;
      state.loading = false;
    },
    [getSingaporeSmsNps.pending]: (state) => {
      state.loading = true;
    },
    [getSingaporeSmsNps.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSingaporeSmsNps.fulfilled]: (state, action) => {
      state.SmsNpsOperation = action.payload;
      state.loading = false;
    },
    [setPriceOperation.pending]: (state) => {
      state.loading = true;
    },
    [setPriceOperation.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setPriceOperation.fulfilled]: (state, action) => {
      state.PriceOperation = action.payload;
      state.loading = false;
    },
    [setSingaporeSmsNps.pending]: (state) => {
      state.loading = true;
    },
    [setSingaporeSmsNps.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setSingaporeSmsNps.fulfilled]: (state, action) => {
      state.SmsNpsOperation = action.payload;
      state.loading = false;
    },
    [setSmsEmailSendingDataForThailand.pending]: (state) => {
      state.loading = true;
    },
    [setSmsEmailSendingDataForThailand.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setSmsEmailSendingDataForThailand.fulfilled]: (state, action) => {
      state.SmsNpsOperation = action.payload;
      state.loading = false;
    },

  }
});

export const priceOperationActions = priceOperationSlice.actions

export default priceOperationSlice;
